<template>
  <message>
    <template slot="icon">
      <i class="far fa-calendar-times text-error" style="font-size: 100px" />
    </template>
    <template slot="text">
      <h3 class="text-error p-t-20">{{ $t('revision-confirm.delete.success') }}</h3>
    </template>
  </message>
</template>
<script>
import Message from '@/components/dialog/Message'

export default {
  name: 'RevisionDeleteConfirm',
  components: {
    Message,
  },
}
</script>
